import { Link } from "react-router-dom";
import { CATEGORIES } from "@/mocks/categories";
import { articlesByCategory } from "@/mocks/articles";
import SectionHeading from "@/components/ui/Section";

export default function CategoryShowcase() {
  return (
    <section className="container-page mt-14 md:mt-20">
      <SectionHeading
        kicker="The Sourcing Desk"
        title="四大圈内信源，谁是真正的线人？"
        desc="你好奇的明星八卦圈内，往往并不来自热搜本身。这里每一个栏目，都有一群愿意开口、又不愿露脸的圈内工作人员与知情者。"
      />
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {CATEGORIES.map((c) => {
          const count = articlesByCategory(c.key).length;
          return (
            <Link
              key={c.key}
              to={`/category/${c.key}`}
              className="group relative flex h-[340px] flex-col justify-end overflow-hidden rounded-lg"
            >
              <img
                src={c.image}
                alt={`${c.name} - ${c.source} 爆料专区`}
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/95 via-foreground-950/30 to-foreground-950/10"></div>
              <div className="relative z-10 p-5">
                <span className="inline-flex items-center gap-1 rounded-sm bg-background-50/15 px-2 py-1 text-[11px] font-semibold text-background-50 backdrop-blur">
                  <i className={c.icon}></i>
                  {c.source} · {count} 篇
                </span>
                <h3 className="mt-2 font-heading text-xl font-extrabold text-background-50">
                  {c.name}
                </h3>
                <p className="mt-1 font-heading text-sm text-accent-300">
                  {c.slogan}
                </p>
                <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-background-200/85">
                  {c.desc}
                </p>
                <span className="mt-3 inline-flex items-center gap-1 text-xs font-semibold text-background-50">
                  进入专栏
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
                </span>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}